import type { SxProps, Theme } from '@mui/material/styles'

type RegisterPageStyleMap = {
    container: SxProps<Theme>
    logoWrapper: SxProps<Theme>
    logoIcon: SxProps<Theme>
    paper: SxProps<Theme>
    errorAlert: SxProps<Theme>
    chooseStep: SxProps<Theme>
    emailMethodButton: SxProps<Theme>
    chooseDivider: SxProps<Theme>
    formStep: SxProps<Theme>
    backRow: SxProps<Theme>
}

export const registerPageStyles: RegisterPageStyleMap = {
    container: { py: 8 },
    logoWrapper: { display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 4 },
    logoIcon: { width: 48, height: 48, bgcolor: 'primary.main', borderRadius: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 },
    paper: { p: 4, border: '1px solid', borderColor: 'divider', borderRadius: 2 },
    errorAlert: { mb: 2 },
    chooseStep: { display: 'flex', flexDirection: 'column', gap: 2 },
    emailMethodButton: { justifyContent: 'flex-start', px: 3, py: 1.5, color: 'text.primary', borderColor: 'divider', '& .MuiButton-startIcon': { marginRight: '12px' } },
    chooseDivider: { my: 0.5 },
    formStep: { display: 'flex', flexDirection: 'column', gap: 2 },
    backRow: { display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 },
}
